var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"duels"},[_c('DuelsControls'),_c('DuelsStats'),_c('DuelsGames'),_c('Bets')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }